exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.disguised-block_overlayClassName_1nu07 {\n    display: none;\n    z-index: 600;\n}\n\n.disguised-block_modalContent_t96GW {\n    width: 98%;\n    height: 98%;\n    margin: 0 auto;\n    outline: none;\n}\n\n.disguised-block_modalContent_t96GW > div {\n    height: 100%;\n}\n\n.disguised-block_modalVisible_1Lvu6 {\n\n}\n\n.disguised-block_menuList_MWr1T > button {\n    margin-left: 5px;\n    background: #1790ff;\n    border: none;\n    outline: none;\n    font-size: 14px;\n    text-align: center;\n    color: #fff;\n    padding: 5px 10px;\n    border-radius: 5px;\n}\n\n.disguised-block_show_37Qmm {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n}\n", ""]);

// exports
exports.locals = {
	"overlayClassName": "disguised-block_overlayClassName_1nu07",
	"modalContent": "disguised-block_modalContent_t96GW",
	"modalVisible": "disguised-block_modalVisible_1Lvu6",
	"menuList": "disguised-block_menuList_MWr1T",
	"show": "disguised-block_show_37Qmm"
};